export default {
  LBL_USERNAME: 'Email Address',
  LBL_PASSWORD: 'Password',
  LBL_PASSWORD_CONFIRM: 'Confirm Password',
  LBL_LOGIN_PAGE_HEADING: 'Administrator Login',
  LBL_LEFT_PANEL_OPT_NAME: 'Left panel option name',
  LBL_LEFT_PANEL_OPT_DESCRIPTION: 'Description',
  LBL_LEFT_PANEL_OPT_LOGO: 'LOGO',
  LBL_PAGE_NAME: 'Page Name',
  LBL_PAGE_URL: 'Page URL',
  LBL_PAGE_LEFT_PANEL_OPT_TAB: 'Left Panel Tab Option',
  LBL_PAGE_PAGE_OPENS_NEW_TAB: 'Page opens in new tab',
  LBL_PAGE_ORDER: 'Page Order',
  LBL_WIDGET_NAME: 'Widget Name',
  LBL_WIDGET_SIZE: 'Widget Size',
  LBL_WIDGET_CAN_HIDE: 'Users can hide widget',
  LBL_WIDGET_UNBOX: 'Unbox Widget',
  LBL_WIDGET_IMG: 'Add Icon Image to Widget',
  LBL_WIDGET_DESC: 'Widget Description',
  LBL_IS_CUSTOM_IMAGE: 'Upload Widget Logo',
  LBL_WIDGET_LOGO: 'Widget Logo',
  LBL_WIDGET_HEIGHT: 'Widget Height',
  LBL_WIDGET_SLUG_ID: 'Select Widget Logo',
  LBL_IS_REPLACE_WITH_CRM_WIDGET: 'Do you want to replace with CRM widget?',
  LBL_CRM_WIDGET_ID: 'Select CRM Widget',
  LBL_RSS_FEED_NAME: 'Feed Name',
  LBL_RSS_FEED_LINK: 'RSS Feed Link',
  LBL_PRODUCT_NAME: 'Product Name',
  LBL_PRODUCT_SIZE: 'Product Size',
  LBL_PRODUCT_SLUG_ID: 'Select Product Logo',
  LBL_PRODUCT_ENROLMENT_TYPE: 'Enrollment Type',
  LBL_PRODUCT_LOGO: 'Product Logo',
  LBL_PRODCT_DESC: 'Product Description',
  LBL_PRODUCT_PRICE: 'Product Price',
  LBL_PRODUCT_CATEGORY: 'Category',
  LBL_PRODUCT_SSO_URL: 'SSO URL',
  LBL_PRODUCT_AUTH_TYPE: 'Type of Authorization for SSO',
  LBL_PRODUCT_HEIGHT: 'Product Height',
  LBL_PRODUCT_ADVANTAGE: 'Advantage',
  LBL_PRODUCT_BENIFITS: 'Benefits',
  LBL_PRODUCT_MARKETPLACE_IMAGE_LINK: 'Marketplace Image',
  LBL_PRODUCT_MEDIA_URL: 'Media',
  LBL_PRODUCT_SHORT_DESC: 'Short Description',
  LBL_PRODUCT_TAGLINE: 'Tagline',
  LBL_PRODUCT_DEAL: 'Deal',
  LBL_PRODUCT_SLUG: 'Slug',
  LBL_PRODUCT_REGISTER_TEXT: 'Register Text',
  LBL_PRODUCT_ACTION_TYPE: 'Action Type',
  LBL_PRODUCT_LEAD_ROUTE: 'Lead Route',
  LBL_PRODUCT_ACTION_URL: 'Action URL',
  LBL_PRODUCT_ACTION_TEXT: 'Action Text',
  LBL_PRODUCT_STATUS: 'Published Status',
  LBL_PRODUCT_ENTERPRISE_ASSOCIATION: 'Enterprise Association',
  LBL_PRODUCT_DOCS: 'Product Documents',
  LBL_PRODUCT_MEDIA_MARKETPLACE_IMAGE: 'Upload Tile Image (only JPEG, JPG, PNG)',
  LBL_PRODUCT_MEDIA_CAROUSEL_NAME: 'Media Carousel Name',
  LBL_PRODUCT_MEDIA_TYPE: 'Type',
  LBL_PRODUCT_MEDIA_CAROUSEL_IMAGE: 'Upload Thumbnail (only JPEG, JPG, PNG)',
  LBL_PRODUCT_MEDIA_PRODUCT_ID: 'Product ID',
  LBL_PRODUCT_MEDIA_CAROUSEL_DOCS: 'Tile Media upload',
  LBL_PRODUCT_MEDIA_ORDER: 'Thumbnail Order',

  LBL_ENTERPRISE_NAME: 'Name',
  LBL_ENTERPRISE_SLUG: 'Slug',
  LBL_ENTERPRISE_DOMAIN: 'Domain',
  LBL_ENTERPRISE_TYPE: 'Type',
  LBL_ENTERPRISE_CRM_ID: 'CRM Enterprise ID',
  LBL_ENTERPRISE_LOGO_URL: 'Logo Url',

  LBL_ENTERPRISE_ADDRESS: 'Address',
  LBL_ENTERPRISE_CITY: 'City',
  LBL_ENTERPRISE_STATE: 'State',
  LBL_ENTERPRISE_ZIP: 'Zip',
  LBL_ENTERPRISE_PHONE: 'Phone',
  LBL_ENTERPRISE_DISPLAY_DOMAIN: 'Display Domain',
  LBL_ENTERPRISE_HELP_LINK: 'Help Link',
  LBL_ENTERPRISE_HOME_TITLE: 'Home Title',
  LBL_ENTERPRISE_HOME_DESCRIPTION: 'Home Description',
  LBL_ENTERPRISE_FACEBOOK_URL: 'Facebook Url',
  LBL_ENTERPRISE_YOUTUBE_URL: 'Youtube Url',
  LBL_ENTERPRISE_TWITTER_URL: 'Twitter Url',
  LBL_ENTERPRISE_LINKEDIN_URL: 'LinkedIn Url',
  LBL_ENTERPRISE_INSTAGRAM_URL: 'Instagram Url',
  LBL_ENTERPRISE_DEFAULT_COUPON: 'Default Coupon',
  LBL_ENTERPRISE_DISCLAIMER: 'Disclaimer',

  LBL_EXCHANGE_LINK_TEXT: 'Exchange Link',
  LBL_HOME_WELCOME_IMAGE_URL: 'Home Welcome Image URL',
  LBL_HOME_EXPLORE_TEXT: 'Home Explore Text',
  LBL_HOME_SHOW_CALCULATOR: 'Home Show Calculator',
  LBL_HOME_CALENDLY_LINK: 'Home Calendly Link',
  LBL_POWERED_BY_URL: 'Powered By Image URL',
  LBL_LOGIN_MODAL_URL: 'Login Modal Image URL',

  LBL_ENTERPRISE_PRODUCTS: 'Linked Products',

  LBL_USER_NAME: 'Name',
  LBL_USER_FIRST_NAME: 'First Name',
  LBL_USER_PROFILE_IMAGE: 'Profile Image',
  LBL_USER_LAST_NAME: 'Last Name',
  LBL_USER_FIRM_NAME: 'Firm Name',
  LBL_USER_RIA_NAME: 'RIA Name',
  LBL_USER_ROLE: 'Role',
  LBL_USER_PARTNER: 'Partner',
  LBL_USER_ADDR1: 'Street Address 1',
  LBL_USER_ADDR2: 'Street Address 2',
  LBL_USER_CITY_NAME: 'City',
  LBL_USER_STATE_NAME: 'State',
  LBL_USER_ZIP: 'Zip',
  LBL_USER_BROK_DEALERS: 'Broker Dealer(s)',
  LBL_USER_CUSTODIANS: 'Custodian(s)',
  LBL_USER_AUN: 'AUM',
  LBL_USER_TRAILING_GDC: '12 Month Trailing GDC',
  LBL_USER_TOTAL_HOUSEHOLDS: 'Number of Households',
  LBL_USER_MEMB_PLAN: 'Membership Plan',
  LBL_USER_PHONE: 'Phone',
  LBL_USER_PHONE_WORK: 'Office Phone',
  LBL_USER_EMAIL: 'Email',
  LBL_STRIPE_CUSTOMER_ID: 'Stripe Customer Id',
  LBL_USER_COMPANY_NAME: 'Company Name',
  LBL_USER_ARCHE_TYPE: 'Which of the following best describes your goal?',
  LBL_ADMIN_ARCHE_TYPE: 'User Archetype',
  LBL_USER_Q1: 'Have you considered a new website for your firm or enhancing your marketing efforts to drive lead generation?',
  LBL_USER_Q2: 'Have you considered a new client relationship management system(CRM) to help manage your client interactions and prospecting efforts?',
  LBL_USER_Q3: 'Have you considered a new all-encompassing system to integrate client data, trading rebalancing, performance reporting, and/or fee-billing to scale your business?',
  LBL_USER_Q4: 'Would you and your clients benefit from the streamlined processes and scale created by professionally managed investment models and programs?',
  LBL_USER_Q5: 'Do you have clients who are accredited investors and might benefit from a variety of high-quality alternative investments?',
  LBL_USER_Q6: 'Have you considered using an online bookeeping system and/or professional bookeeping or CFO services to reduce administrative tasks, help ensure your finances are compliant, and have professional financial records?',
  LBL_USER_Q7: 'Have you considered group medical insurance, outsourced human resource services(HR), and payroll services to help ensure cost-effective benefits and compliance with state and federal laws?',
  LBL_USER_Q8: 'Have you considered buying a practice to grow your business or selling your practice as means of monetizing your firm?',
  LBL_USER_Q9: 'Have you considered exploring new broker-dealer affiliations to help grow your business?',
  LBL_USER_Q10: 'Have you considered transitioning your business to free-based and joining an existing corporate RIA or establishing your own RIA?',
  LBL_MEMB_PLAN_NAME: 'Plan Name',
  LBL_MEMB_PLAN_PRICE: 'Price (In Dollar)',
  LBL_MEMB_PLAN_INTERVAL_TYPE: 'Billed Frequency',
  LBL_MEMB_PLAN_DESC: 'Description',
  LBL_MEMB_PLAN_CURR_TYPE: 'Currency Type',
  LBL_MEMB_PLAN_INTERVAL_COUNT: 'Interval Count',
  LBL_PRODUCT_CAN_HIDE: 'Users can hide product',
  LBL_ROLE_NAME: 'Role Name',
  LBL_ROLE_DESCRIPTION: 'Role Description',
  LBL_CRM_WIDGET_NAME: 'CRM Widget Name',
  LBL_CRM_WIDGET_SIZE: 'CRM Widget Size',
  LBL_CRM_WIDGET_HEIGHT: 'CRM Widget Height',
  LBL_CRM_WIDGET_DESCRIPTION: 'Description',
  LBL_REDTAIL_LOGIN_USERNAME: 'USERNAME',
  LBL_REDTAIL_LOGIN_PWD: 'PASSWORD',
  LBL_REDTAIL_LOGIN_OTP: 'One Time Password',
  LBL_PROSITE_LOGIN_SITEID: 'SITE ID',
  LBL_PROSITE_LOGIN_EMAIL: 'EMAIL',
  LBL_PARTNER_CRM_ID: 'CRM Account',
  LBL_PARTNER_NAME: 'Partner Name',
  LBL_PARTNER_CONTACT_NAME: 'Contact Name',
  LBL_PARTNER_CONTACT_EMAIL: 'Contact Email',
  LBL_PARTNER_CONTACT_CALENDAR: 'Contact Calendar',
  LBL_PARTNER_CONTACT_ALTERNATE_EMAIL1: 'Alternate Email 1',
  LBL_PARTNER_CONTACT_ALTERNATE_EMAIL2: 'Alternate Email 2',
  LBL_PARTNER_SLUG: 'Slug',
  LBL_PARTNER_WEBSITE: 'Partner Website',
  LBL_PARTNER_DESCRIPTION: 'Description',
  LBL_PARTNER_LOGO: 'Logo',
  LBL_PRODUCT_TAG_NAME: 'Name',
  LBL_PRODUCT_TAG_SLUG: 'SLUG',
  LBL_PRODUCT_TAG_GROUP: 'Group',
  LBL_EVENT_NAME: 'Event Name',
  LBL_EVENT_TYPE: 'Event Type',
  LBL_EVENT_DATE: 'Event Date',
  LBL_EFFECTIVE_DATE_PORTAL: 'Effective Date',
  LBL_SAVINGS_PORTAL: 'Estimated Savings',
  LBL_EVENT_SOURCE: 'Source Type',
  LBL_EVENT_DESC: 'Description',
  LBL_EVENT_LINK: 'Link',
  LBL_EVENT_MEDIA_URL: 'Media URL',
  LBL_EVENT_ORDER: 'Event Order',
  LBL_EVENT_IS_PUBLIC: 'Show for Public',
  LBL_EVENT_IS_PAID: 'Show for Paid',
  LBL_EVENT_IS_REGISTERED: 'Show for Registered',
  LBL_HOW_CAN_WE_HELP: 'How can we help you? (Optional)',
  LBL_USER_EMAIL_LINK: 'Email Link',
  LBL_USER_SET_PASSWORD_LINK: 'Set Password Link',
  LBL_FAQ_QUESTION: 'Question',
  LBL_FAQ_ANSWER: 'Answer',
  LBL_WEBSITE_DOMAIN: 'Website Domain',
  LBL_COMPANY_REVENUE: 'Company Revenue',
  LBL_NUM_EMPLOYEES: 'Number of Employees',
  LBL_PREVIOUS_CLAIMS: 'Within the last 3 years have you suffered any cyber incidents resulting in a claim in excess of $25,000?',
  LBL_CLAIMS_EXPLANATION: 'Please explain the cyber incidents and/or claims',
  LBL_RISE_TO_CLAIMS_EXPLANATION: 'Please explain the circumstances and/or potential claims',
  LBL_CC_CUSTOMER_COUNT: 'How many credit card customers does the applicant have?',
  LBL_PII_PHI_COUNT: 'How many customer PII or PHI records does the applicant have?',
  LBL_BUSINESS_EMAIL: 'Business Email',
  LBL_TITLE: 'Title (Optional)',
  LBL_PHONE_OPTIONAL: 'Phone Number (Optional)',
  LBL_EFFECTIVE_DATE: 'Desired Effective Date',
  LBL_SURVEY_QUESTION: 'Question',
  LBL_SURVEY_ORDER: 'Order',
  LBL_BECOME_MEMBER: 'Would you like to become a member of Chalice Financial Network?',

  LBL_BANNER_LINK: 'Image URL',
  LBL_BANNER_DISPLAY: 'Display on Exchange',
  LBL_BANNER_IMAGE: 'Upload Image',
  LBL_BANNER_PRODUCT: 'Select Product',
  LBL_JOB_TITLE: 'Job Title',
  LBL_INDUSTRY: 'Industry',
  LBL_NUMBER_OF_EMPLOYEES: 'Number of employees',
  LBL_PRICING_TIER: 'Pricing Tier',
  LBL_ORGANIZATION_ADMIN: 'User is an organization admin?',
  LBL_ORGANIZATION_AUTO_ADD_MEMBER: 'If the user exists automatically add them to the organization?',
  LBL_ACCESS_BILLING: 'User can access billing?',
  LBL_REQUEST_CONSULTATIONS: 'User can request consultations?',
  LBL_BILLING_EMAIL: 'Billing Email',
  LBL_ORGANIZATION_NAME: 'Organization Name'
}
